import React, { useState } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core";
import NavBar from "./NavBar";
import TopBar from "./TopBar";

const useStyles = makeStyles((theme) => ({
  root: {
    background: "linear-gradient(#000, #362e9e)",
    display: "flex",
    height: "100%",
    overflow: "hidden",
    width: "100%",
  },
  wrapper: {
    display: "flex",
    flex: "1 1 auto",
    overflow: "hidden",
    paddingTop: 70,
    // backgroundImage:"url(/Users/administrator/Desktop/super/digital-asset-store-21033983-reactjs-superadmin/public/images/background.png)"
    [theme.breakpoints.up("lg")]: {
      paddingLeft: 256,
    },
  },
  // Background color change ......
  contentContainer: {
    display: "flex",
    flex: "1 1 auto",
    overflow: "hidden",
    // background: "linear-gradient(#00000014, #211c61)",
    backgroundImage: `url(${"/images/background.png"})`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    color: "#fff",
    minHeight: "93vh",
    marginTop: "24px",
    padding: "50px",
  },
  content: {
    flex: "1 1 auto",
    height: "100%",
    overflow: "hidden",
    position: "relative",
    WebkitOverflowScrolling: "touch",
    padding: "10px 50px 10px ",
    // [theme.breakpoints.down("sm")]: {
    //   padding: "10px 20px 1 10px ",
    // },
    background: "hsla(0,0%,100%,.03)",
    [theme.breakpoints.down("xs")]: {
      padding: "10px 16px 10px ",
    },
  },
}));

const DashboardLayout = ({ children }) => {
  const classes = useStyles();
  const [isMobileNavOpen, setMobileNavOpen] = useState(false);

  return (
    <>
      <div className={classes.root}>
        <TopBar onMobileNavOpen={() => setMobileNavOpen(true)} />
        <NavBar
          onMobileClose={() => setMobileNavOpen(false)}
          openMobile={isMobileNavOpen}
        />
        <div className={classes.wrapper}>
          <div className={classes.contentContainer}>
            <div className={classes.content} id="main-scroll">
              {children}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

DashboardLayout.propTypes = {
  children: PropTypes.node,
};

export default DashboardLayout;
